export interface SubscriptionStatus {
    status: SubscriptionStatusEnum;
    activeFrom?: string;
    activeTo?: string;
    remainingInvoices?: number;
    tariffId?: string;
    invoiceLimit?: number;
    usedInvoices?: number;
    pendingPaymentInvoiceId?: string;
    trialUsed?: boolean;
}

export type SubscriptionStatusError = {
    response: {
        data: {
            code: number;
            fieldName: string;
            message: string;
        };
    };
};

export enum SubscriptionStatusEnum {
    INACTIVE = 'INACTIVE',
    PAYMENT_PENDING = 'PAYMENT_PENDING',
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
}

export interface SubscriptionTariff {
    id: string;
    available: boolean;
    periodDays: number;
    invoiceLimit: number;
    amount: number;
    currencyCode: string;
}
